import { useState } from 'react'
import { useModal } from '@ebay/nice-modal-react'

import { useMessage } from '@pepper/ui'

import { useSelectedCompanyId } from 'utils/functions/misc'
import { createPrivateDocument } from 'utils/api/item'
import { redirectToNewDoc } from 'utils/functions/redirectToNewDoc'

import SubMenuBtn from '../SubMenuBtn'

import s from './AIDocMenu.module.css'

type Props = {
  onClose: () => void
  projectId?: string
}

const AIDocMenu = ({ onClose, projectId }: Props) => {
  const companyId = useSelectedCompanyId()
  const { show } = useModal('select-project-modal')
  const { showError } = useMessage()

  const [isCreatingDoc, setIsCreatingDoc] = useState(false)

  const handleCreateDoc = async (
    _projectId: string,
    openAiWidget = false
  ): Promise<string | undefined> => {
    const { data, status, error } = await createPrivateDocument({
      projectId: _projectId,
    })
    if (status === 'ok' && data) {
      redirectToNewDoc(data.item_id, openAiWidget, companyId)
    } else {
      showError(error)
      return undefined
    }
  }

  const handleCreateDocClick = async (openAiWidget = false) => {
    setIsCreatingDoc(true)
    if (projectId) {
      handleCreateDoc(projectId, openAiWidget)
    } else {
      show({
        onAfterSelectId: async (_projectId: string) => {
          handleCreateDoc(_projectId, openAiWidget)
        },
      })
    }
    setIsCreatingDoc(false)
    onClose()
  }

  return (
    <div className={s.wrapper}>
      <SubMenuBtn
        onClick={() => handleCreateDocClick(false)}
        loading={isCreatingDoc}
        showArrowIcon={false}
      >
        Start with a Blank Doc
      </SubMenuBtn>
      <SubMenuBtn
        onClick={() => handleCreateDocClick(true)}
        loading={isCreatingDoc}
        showArrowIcon={false}
      >
        Create Content using AI prompts
      </SubMenuBtn>
    </div>
  )
}

export default AIDocMenu
